import { render, staticRenderFns } from "./RecommendedLimitDialog.vue?vue&type=template&id=1c00140a"
import script from "./RecommendedLimitDialog.vue?vue&type=script&lang=js"
export * from "./RecommendedLimitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports